const ELLIPSIS = '...';

/** Max characters shown for org filter labels (including "..."). */
export const MENU_LABEL_MAX_CHARS = 40;

export const formatMenuLabelText = (raw) => {
  if (raw == null || raw === '') return '';
  const text = String(raw);
  if (text.length <= MENU_LABEL_MAX_CHARS) return text;
  const headLen = MENU_LABEL_MAX_CHARS - ELLIPSIS.length;
  return `${text.slice(0, headLen)}${ELLIPSIS}`;
};

export const isMenuLabelTruncated = (raw) => {
  if (raw == null || raw === '') return false;
  return String(raw).length > MENU_LABEL_MAX_CHARS;
};
